import { render } from "./MainLinhVuc.vue?vue&type=template&id=3a5a92aa&scoped=true"
import script from "./MainLinhVuc.vue?vue&type=script&scope=this%20api%20replaced%20by%20slot-scope%20in%202.5.0%2B&lang=js"
export * from "./MainLinhVuc.vue?vue&type=script&scope=this%20api%20replaced%20by%20slot-scope%20in%202.5.0%2B&lang=js"

import "./MainLinhVuc.vue?vue&type=style&index=0&id=3a5a92aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5a92aa"]])

export default __exports__